import { apiClientGeral } from '@/plugins/axios'

export default {
  getGruposDeRotas() {
    return apiClientGeral().get('/grupo-rotas')
  },
  getSpecificGrupoDeRotas(id) {
    return apiClientGeral().get(`/grupo-rotas/${id}`)
  },
  getGrupoDeRotasUse(id) {
    return apiClientGeral().get(`/grupo-rotas/use/${id}`)
  },
  postGrupoDeRotas(form) {
    return apiClientGeral().post('/grupo-rotas', form)
  },
  putGrupoDeRotas(id, form) {
    return apiClientGeral().put(`/grupo-rotas/${id}`, form)
  },
  deleteGrupoDeRotas(id) {
    return apiClientGeral().delete(`/grupo-rotas/${id}`)
  },
}